import React__default from 'react';
import { dayjs, ImportStatus, KpkMetaFieldType } from '@keepeek/commons';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import DefaultIcon from '../../DefaultIcon/index.js';
import { ElementMetaField } from '../../ElementMetaField/index.js';
import ElementSummary from '../../ElementSummary/index.js';
import { useUploadElement } from '../../providers/upload/hooks/useUploadElement.js';

var ImportElement = function (_a) {
    var uploadKey = _a.uploadKey, uuid = _a.uuid, _b = _a.testId, testId = _b === void 0 ? "ImportElement" : _b, className = _a.className, _c = _a.KIcon, KIcon = _c === void 0 ? DefaultIcon : _c;
    var date = dayjs();
    var t = useTranslation("refront-components").t;
    var element = useUploadElement(uploadKey, uuid).kpkMediaImport;
    // In case the uuid doesn't match an element in the store
    if (!element) {
        return null;
    }
    return (React__default.createElement(ElementSummary, { "aria-hidden": true, "aria-disabled": true, allowSelection: false, allowNavigation: false, element: element, iconOverMedia: React__default.createElement(React__default.Fragment, null,
            (element.status === ImportStatus.UPLOADING || element.status === ImportStatus.ADDED) && (React__default.createElement(Box, { sx: { color: function (theme) { return theme.palette.grey[900]; } } },
                React__default.createElement("p", null, element.status === ImportStatus.UPLOADING
                    ? t("components.ImportElement.uploadInProgress.label")
                    : t("components.ImportElement.waitingForUpload.label")),
                React__default.createElement("p", null,
                    element.progress,
                    "%"))),
            element.status === ImportStatus.SUCCESS && element.previewUrl === "" && (React__default.createElement(KIcon, { sx: { fontSize: "100px", color: function (theme) { return theme.palette.common.white; } }, className: "fa-regular fa-circle-check" }))), sx: {
            "& .MuiCardMedia-root": {
                backgroundImage: element.status === ImportStatus.SUCCESS ? "" : "unset !important",
                backgroundColor: function (theme) {
                    return element.status === ImportStatus.SUCCESS && element.previewUrl === ""
                        ? theme.palette.grey[500]
                        : "unset";
                }
            },
            fontSize: "0.875rem"
        }, className: clsx("ImportElement", className), "data-testid": testId },
        React__default.createElement(Box, { sx: {
                paddingTop: function (theme) { return theme.spacing(1); },
                color: function (theme) { return theme.palette.common.black; }
            } },
            React__default.createElement(ElementMetaField, { className: "ImportElement-date", field: {
                    id: "date",
                    value: date.toString(),
                    loading: false,
                    name: "Date",
                    type: KpkMetaFieldType.Date
                }, summaryDisplay: true, KIcon: KIcon }),
            React__default.createElement(Typography, { className: "ImportElement-filename", variant: "caption", sx: {
                    fontWeight: "bold"
                } }, element.originalFileName),
            React__default.createElement(Typography, { className: "ImportElement-mediaType", sx: {
                    color: "rgba(53, 53, 53, 0.87)",
                    width: "fit-content",
                    fontSize: "0.75rem",
                    fontWeight: "bold",
                    background: function (theme) { return theme.palette.grey[200]; },
                    padding: function (theme) { return theme.spacing(0.25, 0.5); },
                    textTransform: "uppercase",
                    marginTop: function (theme) { return theme.spacing(0.5); }
                } }, element.mediaType))));
};

export { ImportElement as default };
//# sourceMappingURL=ImportElement.js.map
